module.exports = __webpack_public_path__ + "static/img/warning_2.3fd23b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/warning_2.png
// module id = 2MNz
// module chunks = 1